import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";

/*
 *  Approval Path Management Service
 * !== 결재선 관리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/comnmdle/aprvpath`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/aprv/aprvPath`,
    nodes: [{ label: "Portal" }, { label: "Common Module" }, { label: "Approval Management" }],
};

export const URLS = {
    osci0108001q: `${BASE.path}/osci0108001q`, // Approval Path Management List !==  결재선 관리 목록 ==!
    osci0108002s: `${BASE.path}/osci0108002s`, // Registration Approval Path Management !==  결재선 관리 등록 ==!
    osci0108003s: `${BASE.path}/osci0108003s`, // Modifying and deleting Approval Path Management !==  결재선 관리 수정 및 삭제 ==!
};

export const APIS = {
    // View Approval Path management list !== 결재선 관리 목록 조회 ==!
    getAprvPathMgmtList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Customs,Section Search List !== 세관,섹션 검색 목록 조회 ==!
    getAprvPathSrchList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/srch?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // View Approval Path Information !== 결재선 등록 정보 조회 ==!
    getAprvPathInfo: (data: any) => {
        return api.get(`${BASE.api}/${data}`);
    },

    // Create Approval Path Information !== 결재선 정보 등록 ==!
    createAprvPathInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    // Update Approval Path Information !== 결재선 정보 수정 ==!
    updateAprvPathInfo: (data: any) => {
        return api.put(`${BASE.api}/${data.aprvPathId}`, {
            ...data,
        });
    },

    // Delete Approval Path Information !== 결재선 정보 삭제 ==!
    deleteAprvPathInfo: (data: any) => {
        return api.delete(`${BASE.api}/${data}`);
    },
};

// Approval Path Management Search Form !== 결재선 관리 검색 폼 ==!
export const SF_APRV_PRCSS_PATH_MGMT_SRCH: TFormSchema = {
    id: "form_aprvPrcssPathMgmtSrch",
    schema: {
        aprvPrcssPathNm: { type: "text", label: "L_APRV_PATH_NM", controlSize: 10 },
        ptlTpCd: { type: "text" },
    },
};

// approval Path Management Form !== 결재선 관리 폼 ==!
export const SF_APRV_PRCSS_PATH_MGMT_INFO: TFormSchema = {
    id: "form_aprvPrcssPathMgmtInfo",
    schema: {
        aprvPrcssPathNm: { type: "text", label: "L_APRV_PATH_NM", controlSize: 10, required: true },
        aprvPrcssPathDesc: { type: "textarea", label: "L_APRV_PATH_DESC", required: true, controlSize: 10, rows: 3 },
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_CD",
            required: true,
            area: "comnCd",
            comnCd: "OSC0088",
            edit: false,
        },
        aprvPrcssPathMgmtId: { type: "text", label: "L_APRV_PRCSS_PATH_MGMT_ID" },
        delYn: { type: "radio", label: "L_DEL_YN" },
        usrDmnId: { type: "text", label: "L_USR_ID", letterCase: "upper" },
        usrNm: { type: "text", label: "L_USR_NM", letterCase: "upper" },
        cstmOfcrCd: { type: "code", label: "L_CSTM_OFCR_CD", area: "cstmOfcrCd" },
        cstmCd: { type: "code", label: "L_CSTM_CD", area: "cstmCd" },
    },
};

//  approval Path Management List Grid Schema !== 결재선 관리 목록 그리드 스키마 ==!
export const SG_APRV_PRCSS_PATH_MGMT_LIST: TGridSchema = {
    id: "grid_aprvPrcssPathMgmtList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_APRV_PATH", binding: "aprvPrcssPathMgmtId", width: "*" }], show: false },
        { cells: [{ header: "L_APRV_PATH_NM", binding: "aprvPrcssPathNm", width: "*" }] },
        { cells: [{ header: "L_APRV_PATH_DESC", binding: "aprvPrcssPathDesc", width: "*" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "20%" }] },
    ],
    body: [
        { cells: [{ binding: "aprvPrcssPathMgmtId", edit: false }] },
        { cells: [{ binding: "aprvPrcssPathNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvPrcssPathDesc", edit: false, align: "left" }] },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
    ],
};

// List of Approvers Grid Schema  !== 결재선 검색 결과 결재자 목록 그리드 스키마  ==!
export const SG_APRV_PATH_SRCH_LIST: TGridSchema = {
    id: "grid_aprvPathSrchList",
    options: { index: true, checkbox: true },
    head: [
        { cells: [{ header: "L_USR_ID", binding: "usrDmnId", width: 150 }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_USR_DMN_ID", binding: "xtnUsrUuid", width: "*" }], show: false },
    ],
    body: [{ cells: [{ binding: "usrDmnId", edit: false }] }, { cells: [{ binding: "usrNm", edit: false }] }],
};

// List of Add Approvers Grid Schema  !== 결재선 검색 결과 그리드 행 추가 그리드 스키마  ==!
export const SG_APRV_PATH_SRCH_ADD_LIST: TGridSchema = {
    id: "grid_aprvPathSrchAddList",
    options: { index: true, checkbox: true },
    head: [
        { cells: [{ header: "L_USR_ID", binding: "usrDmnId", width: 150 }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_USR_DMN_ID", binding: "xtnUsrUuid", width: "*" }], show: false },
    ],
    body: [{ cells: [{ binding: "usrDmnId", edit: false }] }, { cells: [{ binding: "usrNm", edit: false }] }],
};
